var api = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./index.module.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = element => {
  const parent = document.getElementsByTagName('bugherd-sidebar')[0];
  parent.shadowRoot.appendChild(element);
};
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};